import { otaUpdatesUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import axios, { isAxiosError } from "axios";

export const downloadConfiguration = async (
  namespace: string,
  sourceId: string,
  firmwareId: string,
) => {
  const url = otaUpdatesUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get<ArrayBuffer>(
      `${url}/api/v1/ns/${namespace}/configuration/download`,
      {
        headers,
        params: {
          source_id: sourceId,
          firmware_id: firmwareId,
        },
        responseType: "arraybuffer",
        responseEncoding: "binary",
      },
    );

    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);

      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to download configuration.",
      );
    } else {
      throw new Error(
        "An unexpected error occurred while downloading configuration.",
      );
    }
  }
};
